import { z } from 'zod';
import { FlowDurationUnits } from '../../../duration/duration.js';
import { FlowDurationSchemaWithMax } from '../../../duration/withMax.js';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { FlowConsumerOfAdvancedFhirResponseSchema } from '../advancedFhir/config.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowConsumerOfFhirPatientResponseSchema, FlowConsumerOfPatientSchema, } from '../consumer.js';
import { FlowBlockType } from '../type.js';
export const FlowHieQueryDocumentsBlockConfigSchema = z.object({
    patient: z.union([
        FlowConsumerOfPatientSchema({ isRequired: false }),
        FlowConsumerOfFhirPatientResponseSchema,
        FlowConsumerOfAdvancedFhirResponseSchema,
    ]),
    facilityId: z.string(),
    timeout: FlowDurationSchemaWithMax({
        pathName: 'timeout',
        max: { value: 30, units: FlowDurationUnits.Minutes },
    }),
});
export const FlowHieQueryDocumentsBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.HieQueryDocuments),
    config: FlowHieQueryDocumentsBlockConfigSchema,
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.Any),
});
//# sourceMappingURL=config.js.map